import './ModerateBookingModal.css';
import { BookingCalendarBooking } from '../../types';
import { DateFormat } from '../../utils/DateFormat';
import ModalPortal from '../modal/ModalPortal';

type Props = {
  booking: BookingCalendarBooking;
  date: string;
  submitting?: boolean;
  onClose: () => void;
  onApprove: () => void;
  onReject: () => void;
};

const ModerateBookingModal = ({
  booking,
  date,
  submitting = false,
  onClose,
  onApprove,
  onReject,
}: Props) => {
  return (
    <ModalPortal>
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Решение по брони</h3>
        <div className="modal-body">
          <label>Дата</label>
          <p>{DateFormat(date)}</p>
          <label>Пилот</label>
          <p>{booking.pilot}</p>
          <label>Статус</label>
          <p>Ожидает решения</p>
        </div>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-cancel"
            onClick={onReject}
            disabled={submitting}
          >
            Отклонить
          </button>
          <button type="button" className="btn-save" onClick={onApprove} disabled={submitting}>
            {submitting ? '...' : 'Одобрить'}
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default ModerateBookingModal;
